import { render, staticRenderFns } from "./CardCategory.vue?vue&type=template&id=e08dbd02&scoped=true"
import script from "./CardCategory.vue?vue&type=script&lang=js"
export * from "./CardCategory.vue?vue&type=script&lang=js"
import style0 from "./CardCategory.vue?vue&type=style&index=0&id=e08dbd02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08dbd02",
  null
  
)

export default component.exports